// Generated by ReScript, PLEASE EDIT WITH CARE


function reducer(state, action) {
  if (typeof state === "number") {
    if (typeof action === "number") {
      return state;
    } else if (action.TAG === /* FetchVehicleQuotationsSuccess */0) {
      return {
              TAG: /* Data */0,
              _0: action._0
            };
    } else {
      return {
              TAG: /* Error */1,
              _0: action._0
            };
    }
  } else if (state.TAG === /* Data */0 || typeof action !== "number") {
    return state;
  } else {
    return /* Init */0;
  }
}

export {
  reducer ,
  
}
/* No side effect */
